import * as ng from 'angular';
import {Action, Task} from "../types/TaskTypes";
import AppConstants from "../gorillaboy/AppConstants";

export interface TasksMessageManager {
    showSuccessMessageForTaskAction: (task : Task, actionId: string) => void;
    showErrorMessageForTaskAction: (task : Task, actionId: string) => void;
};


function TasksMessageManagerFactory($log : ng.ILogService, $translate : ng.translate.ITranslateService,
    MessageManager : any) : TasksMessageManager {

    function showSuccessMessageForTaskAction(task : Task, actionId: string) {
        let key = "TASKS.LIST_VIEW.ERROR_MESSAGES.ACTION_INVOCATION_SUCCEEDED";
        if (task.TaskDefinitionId === AppConstants.TASKDEF_IDS.REQUEST_ACCESS) {
            key = 'TASKS.LIST_VIEW.SUCCESS_MESSAGE.REQUEST_ACCESS.' + actionId;
        } else if (task.TaskDefinitionId === AppConstants.TASKDEF_IDS.TRANSFER_RESOURCE_OWNERSHIP) {
            key = 'TASKS.LIST_VIEW.SUCCESS_MESSAGE.TRANSFR_RESOURCE_OWNERSHIP.' + actionId;
        }
        MessageManager.addSuccessMessage($translate.instant(key, {
            ResourceName: task.RelatedResourceName
        }));
    }

    function showErrorMessageForTaskAction(task : Task, actionId: string) {
        let key = 'TASKS.LIST_VIEW.ERROR_MESSAGES.ACTION_INVOCATION_FAILED';
        MessageManager.addErrorMessage($translate.instant(key, {
            ResourceName: task.RelatedResourceName
        }));
    }

    return {
        showErrorMessageForTaskAction,
        showSuccessMessageForTaskAction
    };
}

TasksMessageManagerFactory.$inject = ['$log',
    '$translate',
    'MessageManager'];

angular.module('GorillaBoy.Tasks')
.factory('TasksMessageManager', TasksMessageManagerFactory);

